import { inject, observer } from 'mobx-react'
import { withRouter } from 'react-router'
import { Route, Switch, useHistory, useLocation } from 'react-router-dom'
import { CSSTransition, TransitionGroup } from "react-transition-group"
import PrivateRoute from './PrivateRoute'
import ReadReport from './containers/ReadReport'
import ReadReportBackoffice from './containers/ReadReportBackoffice'
import { PasswordPolicySwitch } from './containers/client/PasswordPolicySwitch/PasswordPolicySwitch'
import UserList from './containers/client/views/UserList'
import Archive from './containers/client/views/archive/Archive'
import ArchivedGroupOrder from './containers/client/views/archive/ArchivedGroupOrder'
import ArchivedReport from './containers/client/views/archive/ArchivedReport'
import { InitiateAtsOrder } from './containers/client/views/ats/initiate-order/InitiateAtsOrder'
import { NewCustomer } from './containers/client/views/ats/new-customer/NewCustomer'
import { NewOrderDone } from './containers/client/views/ats/new-order-done/NewOrderDone'
import SimulatedAtsNewReportDone from './containers/client/views/ats/simulated-new-order-done/SimulatedAtsNewReportDone'
import Faq from './containers/client/views/faq/Faq'
import GroupedOrderList from './containers/client/views/grouped-orders/Delivered/DeliveredGroupedOrder'
import NewGroupedOrder from './containers/client/views/grouped-orders/NewGroupedOrder'
import PreviewGroupOrder, { PreviewGroupOrderBackoffice } from './containers/client/views/grouped-orders/PreviewGroupOrderBackoffice'
import NewReportDone from './containers/client/views/new-report-done/NewReportDone'
import NewReportOrder from './containers/client/views/new-report-order/NewReportOrder'
import NewReportStart from './containers/client/views/new-report-start/NewReportStart'
import Reports from './containers/client/views/reports/Reports'
import StartClient from './containers/client/views/start-client/StartClient'
import SubCompanies from './containers/client/views/sub-companies/SubCompanies'
import CreatePassword from './containers/create-password/CreatePassword'
import ForgotCreatePassword from './containers/forgot-create-password/ForgotCreatePassword'
import { GeneralTermsApproval } from './containers/general-terms-approval/GeneralTermsApproval'
import { GeneralTerms } from './containers/general-terms/GeneralTerms'
import LoginClient from './containers/login-client/LoginClient'
import LoginFailWithSsoRedirect from './containers/login-client/Sso/LoginFailWithSsoRedirect'
import LoginWithSsoRedirect from './containers/login-client/Sso/LoginWithSsoRedirect'
import SsoDirectRedirect from './containers/login-client/Sso/SsoDirectRedirect'
import MyAccount from './containers/my-account/myaccount'
import { MyOrganisation } from './containers/my-organisation/MyOrganisation'
import PageNotFound from './containers/page-not-found/PageNotFound'

const Main = observer(() => {
	const location = useLocation()
	const history = useHistory()

	return (
		<div className="fill">
			<TransitionGroup>
				<CSSTransition
					key={location.key}
					classNames="fade"
					timeout={300}
				>
					<Switch location={location}>
						<Route exact path="/" component={LoginClient} />
						<Route exact path="/ats" component={InitiateAtsOrder} />
						<Route exact path="/ats-new-customer" component={NewCustomer} />
						<Route exact path="/ats-sim" component={SimulatedAtsNewReportDone} />
						<Route exact path="/ats-confirmed-order" component={NewOrderDone} />
						<Route exact path="/login" component={LoginClient} />
						<Route exact path="/sso" component={LoginWithSsoRedirect} />
						<Route exact path="/sso/fail" component={LoginFailWithSsoRedirect} />
						<Route exact path="/sso/:companyId" component={SsoDirectRedirect} />
						<Route exact path="/forgot-create-password" component={ForgotCreatePassword} />
						<Route exact path="/create-password" component={CreatePassword} />
						<Route exact path="/report-backoffice/:orderId" component={ReadReportBackoffice} />
						<Route path="/previewgrouporder/:companyId/:groupId" component={() => <PreviewGroupOrder />} />
						<Route path="/previewgrouporder-backoffice/:companyId/:groupId" component={() => <PreviewGroupOrderBackoffice />} />

						<PrivateRoute path="/report/:deliveryId" component={() => <ReadReport closeReport={() => history.push('/reports')} />} />
						<PrivateRoute path="/password-policy-switch" component={() => <PasswordPolicySwitch />} />
						<PrivateRoute path="/start" component={StartClient} />
						<PrivateRoute path="/service-packages/:companyId" component={NewReportStart} />
						<PrivateRoute path="/new-report-order/:companyId/:reportPackageId" component={NewReportOrder} />
						<PrivateRoute path="/reports" component={Reports} />
						<PrivateRoute path="/sub-companies" component={SubCompanies} />
						<PrivateRoute path="/myaccount" component={MyAccount} />
						<PrivateRoute path="/myorganisation" component={MyOrganisation} />
						<PrivateRoute path="/list" component={UserList} />
						<PrivateRoute path="/grouporder/:groupId" component={() => <GroupedOrderList hideBackButton={true} />} />
						<PrivateRoute path="/grouporder/" component={() => <NewGroupedOrder />} />
						<PrivateRoute path="/new-report-done/:companyId" component={NewReportDone} />
						<PrivateRoute path="/read-report/:orderId" component={ReadReport} />
						<PrivateRoute path="/faq" component={Faq} />
						<PrivateRoute path="/general-terms" component={GeneralTerms} />
						<PrivateRoute path="/general-terms-approval" component={GeneralTermsApproval} />
						<PrivateRoute path="/archive" component={Archive} />
						<PrivateRoute path="/archived-report/:orderId" component={ArchivedReport} />
						<PrivateRoute path="/archived-group-order/:groupOrderId" component={ArchivedGroupOrder} />
						<Route component={PageNotFound} />
					</Switch>
				</CSSTransition>
			</TransitionGroup>
		</div>
	)
})

export default inject('rootStore')(withRouter(Main))